
import {
  TICKET_LIST_DATA,
  TICKET_DETAILS_DATA,
  TICKET_INSIGHT_DETAILS_DATA,
  TICKET_ARTICLE_DATA,
  TICKET_DETAILS_ADD_DATA,
  TICKET_MESSAGE_ADD_DATA,
  TICKET_SOLUTION_ADD_DATA,
  GET_USER_TICKET_FILTER_DATA,
  USER_TICKET_FILTER_ADD_DATA,
  USER_TICKET_FILTER_DELETE_DATA,
  ADMIN_TICKETS,
  WORKFLOW_DETAILS_DATA,
  MESSAGE_TEMPLATE_DROPDOWN,
  TICKET_FILTER_DATA,
  WORKFLOW_DETAILS_ADD_DATA,
  TICKET_DELETE_DATA,
  WORKFLOW_DELETE_DATA,
  TICKET_BULK_UPDATE_DATA,
  TICKET_ERROR_LOG_DATA,
  TICKET_EMAIL_EXECUTION_LOG_DATA,
  TICKET_DASHBOARD_METRIC_DATA,
  TICKET_ATTACHMENT_ADD_DATA,
  TICKET_ATTACHMENT_DELETE_DATA,
  
} from "./Constants";

const initialState = {
  loading: false,
  error: null,
  ticketlist: {},
  ticketdetails: {},
  workflowdetails: {},
  article: {},
  tickets: {},
  message: [],
  solution: [],
  insights: [],
  filterlist: [],
  workflows: [],
  workflowSaveSuccess: false,
  ticket : [],
  ticketDeleteSuccess: false,
  workflow: [],
  workflowDeleteSuccess: false,
  bulkUpdateSuccess: false,
  bulkUpdateLoading: false,
  errorLogs: [],
  emailExecutionLogs: [],
  dashboardmetrics: {},
  attachmentUploading: false,
  attachmentUploadSuccess: false,
};

const initialMsgTemplatesState = {
  loading: false,
  error: null,
  templates: [],
};
const initialUserTicketFilterState = {
  loading: false,
  error: null,
  userFilterList: [],
};

const initialAdminTicketsState = {
  loadingTicket: false,
  queryData: [],
  rowCount: 0,
  error: null,
};

export const Reducer = (state = initialState, action) => {
  switch (action.type) {

    //load all list
    case TICKET_LIST_DATA.TICKET_LIST_DATA_LOAD:
      return {
        ...state,
        loading: true,
        ticketlist: {},
        error: null,
      };
    case TICKET_LIST_DATA.TICKET_LIST_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        ticketlist: {data: action.ticketlist},
      };
    case TICKET_LIST_DATA.TICKET_LIST_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

      //Get by id
    case TICKET_DETAILS_DATA.TICKET_DETAILS_DATA_LOAD:
      return {
        ...state,
        loading: true,
        ticketdetails: {},
        error: null,
      };
    case TICKET_DETAILS_DATA.TICKET_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        ticketdetails: action.ticketdetails,
        error: null,
      };
    case TICKET_DETAILS_DATA.TICKET_DETAILS_DATA_FAIL:
      return {
        ...state,
        loading: false,
        ticketdetails: {},
        error: action.error,
      };
    //Get by id
    case TICKET_INSIGHT_DETAILS_DATA.TICKET_INSIGHT_DETAILS_DATA_LOAD:
      return {
        ...state,
        loading: true,
        insights: {},
        error: null,
      };
    case TICKET_INSIGHT_DETAILS_DATA.TICKET_INSIGHT_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        insights: action.insights,
        error: null,
      };
    case TICKET_INSIGHT_DETAILS_DATA.TICKET_INSIGHT_DETAILS_DATA_FAIL:
      return {
        ...state,
        loading: false,
        insights: {},
        error: action.error,
      };  
           //Get workflow details by id
    case WORKFLOW_DETAILS_DATA.WORKFLOW_DETAILS_DATA_LOAD:
      return {
        ...state,
        loading: true,
        workflowdetails: {},
        error: null,
      };
    case WORKFLOW_DETAILS_DATA.WORKFLOW_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        workflowdetails: action.workflowdetails,
        error: null,
      };
    case WORKFLOW_DETAILS_DATA.WORKFLOW_DETAILS_DATA_FAIL:
      return {
        ...state,
        loading: false,
        workflowdetails: {},
        error: action.error,
      };
      //Get article by id
    case TICKET_ARTICLE_DATA.TICKET_ARTICLE_DATA_LOAD:
      return {
        ...state,
        loading: true,
        article: {},
        error: null,
      };
    case TICKET_ARTICLE_DATA.TICKET_ARTICLE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        article: action.article,
        error: null,
      };
    case TICKET_ARTICLE_DATA.TICKET_ARTICLE_DATA_FAIL:
      return {
        ...state,
        loading: false,
        article: {},
        error: action.error,
      };
     // Save ticket
    case TICKET_DETAILS_ADD_DATA.TICKET_DETAILS_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        tickets: {},
        error: null,
      };
    case TICKET_DETAILS_ADD_DATA.TICKET_DETAILS_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: action.tickets,
        error: null,
      };
    case TICKET_DETAILS_ADD_DATA.TICKET_DETAILS_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        tickets: {},
        error: action.error,
      };
      // Save message
    case TICKET_MESSAGE_ADD_DATA.TICKET_MESSAGE_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        message: [],
        error: null,
      };
    case TICKET_MESSAGE_ADD_DATA.TICKET_MESSAGE_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.message,
        error: null,
      };
    case TICKET_MESSAGE_ADD_DATA.TICKET_MESSAGE_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        message: [],
        error: action.error,
      }; 
    // Save solution
    case TICKET_SOLUTION_ADD_DATA.TICKET_SOLUTION_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        solution: [],
        error: null,
      };
    case TICKET_SOLUTION_ADD_DATA.TICKET_SOLUTION_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        solution: action.solution,
        error: null,
      };
    case TICKET_SOLUTION_ADD_DATA.TICKET_SOLUTION_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        solution: [],
        error: action.error,
      };  
      
    // ADD  TICKET FILTER 
    case TICKET_FILTER_DATA.TICKET_FILTER_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case TICKET_FILTER_DATA.TICKET_FILTER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        filterList: action.filterList,
        error: null,
      };

    case TICKET_FILTER_DATA.TICKET_FILTER_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    // Save workflow
    case WORKFLOW_DETAILS_ADD_DATA.WORKFLOW_DETAILS_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        workflowSaveSuccess: false, 
        workflows: [],
        error: null,
      };

    case WORKFLOW_DETAILS_ADD_DATA.WORKFLOW_DETAILS_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        workflowSaveSuccess: true, 
        workflows: action.workflows,
        error: null,
      };

    case WORKFLOW_DETAILS_ADD_DATA.WORKFLOW_DETAILS_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        workflowSaveSuccess: false,
        workflows: {},
        error: action.error,
      };

    // Delete 
    case TICKET_DELETE_DATA.TICKET_DELETE_LOAD:
      return {
        ...state,
        loading: true,
        ticket: {},
        ticketDeleteSuccess: false,
        error: null,
      };
    case TICKET_DELETE_DATA.TICKET_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        ticket: action.ticket,
        ticketDeleteSuccess: true,
        error: null,
      };
    case TICKET_DELETE_DATA.TICKET_DELETE_FAIL:
      return {
        ...state,
        loading: false,
        ticket: {},
        ticketDeleteSuccess: false,
        error: action.error,
      };
    
    // Delete 
    case WORKFLOW_DELETE_DATA.WORKFLOW_DELETE_LOAD:
      return {
        ...state,
        loading: true,
        workflow: {},
        workflowDeleteSuccess: false,
        error: null,
      };
    case WORKFLOW_DELETE_DATA.WORKFLOW_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        workflow: action.workflow,
        workflowDeleteSuccess: true,
        error: null,
      };
    case WORKFLOW_DELETE_DATA.WORKFLOW_DELETE_FAIL:
      return {
        ...state,
        loading: false,
        workflow: {},
        workflowDeleteSuccess: false,
        error: action.error,
      };
      // error logs
    case TICKET_ERROR_LOG_DATA.TICKET_ERROR_LOG_DATA_LOAD:
      return { 
        ...state,
        loading: true,
        errorLogs: [], 
        error: null 
      };
    case TICKET_ERROR_LOG_DATA.TICKET_ERROR_LOG_DATA_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        errorLogs: action.errorLogs, 
        error: null 
      };
    case TICKET_ERROR_LOG_DATA.TICKET_ERROR_LOG_DATA_FAIL:
      return { 
        ...state, 
        loading: false, 
        errorLogs: [], 
        error: action.error 
      };
     // email execution logs
    case TICKET_EMAIL_EXECUTION_LOG_DATA.TICKET_EMAIL_EXECUTION_LOG_DATA_LOAD:
      return { 
        ...state, 
        loading: true, 
        emailExecutionLogs: [], 
        error: null };
    case TICKET_EMAIL_EXECUTION_LOG_DATA.TICKET_EMAIL_EXECUTION_LOG_DATA_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        emailExecutionLogs: action.emailExecutionLogs, 
        error: null 
      };
    case TICKET_EMAIL_EXECUTION_LOG_DATA.TICKET_EMAIL_EXECUTION_LOG_DATA_FAIL:
      return { 
        ...state, 
        loading: false, 
        emailExecutionLogs: [], 
        error: action.error 
      };    

    // Bulk update
    case TICKET_BULK_UPDATE_DATA.TICKET_BULK_UPDATE_LOAD:
      return {
        ...state,
        bulkUpdateLoading: true,
        bulkUpdateSuccess: false,
        error: null,
      };
    case TICKET_BULK_UPDATE_DATA.TICKET_BULK_UPDATE_SUCCESS:
      return {
        ...state,
        bulkUpdateLoading: false,
        bulkUpdateSuccess: true,
        error: null,
      };
    case TICKET_BULK_UPDATE_DATA.TICKET_BULK_UPDATE_FAIL:
      return {
        ...state,
        bulkUpdateLoading: false,
        bulkUpdateSuccess: false,
        error: action.error,
      };
    //load dashboard metrics
    case TICKET_DASHBOARD_METRIC_DATA.TICKET_DASHBOARD_METRIC_DATA_LOAD:
      return {
        ...state,
        loading: true,
        dashboardmetrics: {},
        error: null,
      };
    case TICKET_DASHBOARD_METRIC_DATA.TICKET_DASHBOARD_METRIC_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        dashboardmetrics:  action.dashboardmetrics,
      };
    case TICKET_DASHBOARD_METRIC_DATA.TICKET_DASHBOARD_METRIC_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };  

    // cases
    case TICKET_ATTACHMENT_ADD_DATA.TICKET_ATTACHMENT_ADD_DATA_LOAD:
      return {
        ...state,
        attachmentUploading: true,
        attachmentUploadSuccess: false,
        error: null,
      };
    case TICKET_ATTACHMENT_ADD_DATA.TICKET_ATTACHMENT_ADD_DATA_SUCCESS:
      return {
        ...state,
        attachmentUploading: false,
        attachmentUploadSuccess: true,
        ticketdetails: {
          ...state.ticketdetails,
          attachments: [...(state.ticketdetails?.attachments || []), ...action.attachment],
        },
        error: null,
      };
    case TICKET_ATTACHMENT_ADD_DATA.TICKET_ATTACHMENT_ADD_DATA_FAIL:
      return {
        ...state,
        attachmentUploading: false,
        attachmentUploadSuccess: false,
        error: action.error,
      };

    case TICKET_ATTACHMENT_DELETE_DATA.TICKET_ATTACHMENT_DELETE_LOAD:
      return { ...state, error: null };
    case TICKET_ATTACHMENT_DELETE_DATA.TICKET_ATTACHMENT_DELETE_SUCCESS:
      return {
        ...state,
        ticketdetails: {
          ...state.ticketdetails,
          attachments: (state.ticketdetails?.attachments || []).filter(
            (a) => a.id !== action.fileId
          ),
        },
      };
    case TICKET_ATTACHMENT_DELETE_DATA.TICKET_ATTACHMENT_DELETE_FAIL:
      return { ...state, error: action.error };  
      
      

    default:
      return {
        ...state,
      };
  }
};


export const UserTicketFilterReducer = (state = initialUserTicketFilterState, action) => {
  switch (action.type) {

    // GET USER FILTER DATA
    case GET_USER_TICKET_FILTER_DATA.TICKET_FILTER_DETAILS_DATA_LOAD:
      return {
        ...state,
        loading: true,
        userFilterList:[],
        error: null,
      };

    case GET_USER_TICKET_FILTER_DATA.TICKET_FILTER_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        userFilterList: action.filterData,
        error: null,
      };

    case GET_USER_TICKET_FILTER_DATA.TICKET_FILTER_DETAILS_DATA_FAIL:
      return {
        ...state,
        loading: false,
        userFilterList: [],
        error: action.error,
      };

    // ADD USER FILTER DATA
    case USER_TICKET_FILTER_ADD_DATA.TICKET_FILTER_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case USER_TICKET_FILTER_ADD_DATA.TICKET_FILTER_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        userFilterList: [...state.userFilterList, action.response],
        error: null,
      };

    case USER_TICKET_FILTER_ADD_DATA.TICKET_FILTER_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
// DELETE USER FILTER DATA
case USER_TICKET_FILTER_DELETE_DATA.TICKET_FILTER_DELETE_DATA_LOAD:
  return {
    ...state,
    loading: true,
    error: null,
  };

case USER_TICKET_FILTER_DELETE_DATA.TICKET_FILTER_DELETE_DATA_SUCCESS:
  return {
    ...state,
    loading: false,
    // remove deleted filter from list
    userFilterList: state.userFilterList.filter((f) => f.id !== action.id),
    error: null,
  };

case USER_TICKET_FILTER_DELETE_DATA.TICKET_FILTER_DELETE_DATA_FAIL:
  return {
    ...state,
    loading: false,
    error: action.error,
  };

    default:
      return state;
  }
};


export const AdminTicketsReducer = (state = initialAdminTicketsState, action) => {
  switch (action.type) {
    
    /** QUERY */
    case ADMIN_TICKETS.QUERY_LOAD:
      return { ...state, loadingTicket: true, error: null };

    case ADMIN_TICKETS.QUERY_SUCCESS:
      return { ...state, loading: false, queryData: action.data };

    case ADMIN_TICKETS.QUERY_FAIL:
      return { ...state, loadingTicket : false, error: action.error };

    /** ROWCOUNT */
    case ADMIN_TICKETS.ROWCOUNT_LOAD:
      return { ...state, loadingTicket: true, error: null };

    case ADMIN_TICKETS.ROWCOUNT_SUCCESS:
      return { ...state, loadingTicket: false, rowCount: action.data.rowCount };

    case ADMIN_TICKETS.ROWCOUNT_FAIL:
      return { ...state, loadingTicket: false, error: action.error };

    default:
      return state;
  }
};

export const messageTemplateDropdownReducer = (state = initialMsgTemplatesState, action) => {
  switch (action.type) {
    case MESSAGE_TEMPLATE_DROPDOWN.MESSAGE_TEMPLATE_DROPDOWN_LOAD:
      return { ...state, loading: true };

    case MESSAGE_TEMPLATE_DROPDOWN.MESSAGE_TEMPLATE_DROPDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        templates: action.payload,
      };

    case MESSAGE_TEMPLATE_DROPDOWN.MESSAGE_TEMPLATE_DROPDOWN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};